export default "__VITE_ASSET__8AFTAb_m__"